export default __webpack_public_path__ + "static/media/kyc-level-passed.76ef06a3.svg";